module.exports = __webpack_public_path__ + "img/link-banner-fr.7d24ca15.png";